import React, { useEffect, useState, useMemo } from 'react';
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import ProcedureBillModal from '../models/ProcedureBillModal';

const EmergencyPatientList = () => {
  const [dropdownOpenIndex, setDropdownOpenIndex] = useState(null);
  const [showProcedureModal, setShowProcedureModal] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [headerLogo, setHeaderLogo] = useState('');
  const navigate = useNavigate();

  // Helper functions
  const getLocalYYYYMMDD = (d = new Date()) => {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const getStoredUser = () => {
    try {
      const s = sessionStorage.getItem("ldata");
      if (s) {
        try { return JSON.parse(s); } catch (e) { }
      }
      const other = localStorage.getItem("data") || localStorage.getItem("ldata") || sessionStorage.getItem("data");
      if (other) {
        try { return JSON.parse(other); } catch (e) { }
      }
    } catch (err) { }
    return null;
  };

  const parseServerDateToLocal = (dateStr) => {
    if (!dateStr) return null;
    if (dateStr instanceof Date) return dateStr;
    const normalized = String(dateStr).trim().replace(' ', 'T');
    const m = normalized.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?/);
    if (!m) return null;
    const year = Number(m[1]);
    const monthIndex = Number(m[2]) - 1;
    const day = Number(m[3]);
    const hour = Number(m[4] ?? 0);
    const minute = Number(m[5] ?? 0);
    const second = Number(m[6] ?? 0);
    return new Date(year, monthIndex, day, hour, minute, second);
  };

  const formatServerDateLocal = (dateStr, opts = { locale: 'en-GB', options: { day: '2-digit', month: 'long', year: 'numeric' } }) => {
    const dt = parseServerDateToLocal(dateStr);
    if (!dt) return '';
    return dt.toLocaleDateString(opts.locale, opts.options);
  };

  const [formData, setFormData] = useState({
    l1: [],
    docs: [],
    cases: [],
    cats: [],
    page_no: 0,
    from: "",
    to: "",
    search_key: '',
  });

  const [totals, setTotals] = useState({
    totalAmount: 0,
    paidAmount: 0,
    dueAmount: 0,
    totalRegCharges: 0
  });

  const [ldata, setLdata] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  // Hover style for view button
  const hoverStyle = `
    .view-btn { visibility: hidden; transition: visibility 0.05s ease-in-out, opacity 0.15s; opacity: 0; }
    .rdt_TableRow:hover .view-btn { visibility: visible; opacity: 1; }
    .view-btn { pointer-events: auto; }
  `;

  // Fetch emergency list
  const initData = async (overrides = {}) => {
    const storedUser = getStoredUser();
    if (storedUser) {
      const maybeIsAdmin =
        storedUser.is_admin === 1 ||
        storedUser.isAdmin === 1 ||
        storedUser.role === 'admin' ||
        storedUser.user_type === 'admin' ||
        storedUser.role_id === 1 || storedUser.role_id === "1" ||
        storedUser.user_role === 'admin';
      setIsAdmin(Boolean(maybeIsAdmin));
    } else {
      setIsAdmin(false);
    }

    const fromVal = overrides.from !== undefined ? overrides.from : formData.from;
    const toVal = overrides.to !== undefined ? overrides.to : formData.to;
    const searchKey = overrides.search_key !== undefined ? overrides.search_key : formData.search_key;

    const fd = new FormData();
    fd.append('page_no', "none");
    fd.append('search_key', searchKey + "");
    if (fromVal) fd.append('from', fromVal);
    if (toVal) fd.append('to', toVal);

    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.getEmergencyListUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      if (response.data.status) {
        const records = response.data.records || [];
        setFormData(prev => ({ ...prev, l1: records }));
        
        let totalAmount = 0, paidAmount = 0, dueAmount = 0, totalRegCharges = 0;
        records.forEach(item => {
          const reg = parseFloat(item.ipd_reg_charges || 0);
          const paid = parseFloat(item.ipd_paid || 0);
          const due = parseFloat(item.ipd_due || 0);
          totalAmount += reg;
          totalRegCharges += reg;
          paidAmount += paid;
          dueAmount += due;
        });
        
        setTotals({ totalAmount, paidAmount, dueAmount, totalRegCharges });
      } else {
        setFormData(prev => ({ ...prev, l1: [] }));
        setTotals({ totalAmount: 0, paidAmount: 0, dueAmount: 0, totalRegCharges: 0 });
      }
    } catch (error) {
      console.error("initData error:", error);
    }
  };

  // Fetch doctors
  const initData1 = async () => {
    const fd2 = new FormData();
    fd2.append('type', "doctor");
    fd2.append('search_key', "");
    fd2.append('page_no', "none");
    fd2.append('user_cre_by', 1 + "");
    
    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd2, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (response.data.status) {
        const records = response.data.records || [];
        setFormData(prev => ({ ...prev, docs: records }));
      }
    } catch (error) {
      console.error("initData1 error:", error);
    }
  };

  // Fetch specialities and cases
  const initData3 = async () => {
    const catFetch = async (cat_type) => {
      try {
        const fd0 = new FormData();
        fd0.append('cat_type', cat_type);
        fd0.append('page_no', "none");
        fd0.append('par_by', 1 + "");
        const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd0, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data.status ? response.data.records || [] : [];
      } catch (err) { return []; }
    };

    try {
      const cats = await catFetch("speciality");
      const caseCat = await catFetch("case");
      setFormData(prev => ({ ...prev, cats: cats, cases: caseCat }));
    } catch (err) {
      console.error("initData3 error:", err);
    }
  };

  // Fetch config header logo
  const fetchConfigData = async () => {
    try {
      const res = await axios.post(`${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`);
      if (res.data.status) {
        setHeaderLogo(res.data.header_logo);
      }
    } catch (err) {
      console.error("Error fetching config:", err);
    }
  };

  // Mount effect
  useEffect(() => {
    const storedUser = getStoredUser();
    if (storedUser) {
      setLdata(storedUser);
      const maybeIsAdmin =
        storedUser.is_admin === 1 ||
        storedUser.isAdmin === 1 ||
        storedUser.role === 'admin' ||
        storedUser.user_type === 'admin' ||
        storedUser.role_id === 1 || storedUser.role_id === "1" ||
        storedUser.user_role === 'admin';
      setIsAdmin(Boolean(maybeIsAdmin));
    } else {
      setLdata(null);
      setIsAdmin(false);
    }

    const today = new Date();
    const todayStr = getLocalYYYYMMDD(today);
    setFormData(prev => ({ ...prev, from: todayStr, to: todayStr }));
    initData({ from: "", to: "" });
  }, []);

  useEffect(() => {
    initData1();
    initData3();
    fetchConfigData();
  }, []);

  // Helper to get doctor name
  const getDoctorNameById = (id, row = null) => {
    if (row && row.ipd_refer_doctor_name) return row.ipd_refer_doctor_name;
    const doctor = formData.docs.find(doc => String(doc.user_id) === String(id));
    if (doctor && doctor.fname) return doctor.fname;
    return id ? String(id) : '';
  };

  // Helper to find name by ID
  const findNameById = (id, array = [], idField = 'id', nameField = 'name') => {
    if (!id) return '';
    const item = array.find(i => String(i[idField]) === String(id));
    return item ? item[nameField] : '';
  };

  // ✅ Check if patient was moved to IPD
  const isMovedToIPD = (row) => {
    const remarks = (row.ipd_remarks || '').toLowerCase();
    return remarks.includes('transferred to ipd') || remarks.includes('moved to ipd');
  };

  // ✅ Move to IPD function
  const handleMoveToIPD = async (row) => {
    const { isConfirmed } = await Swal.fire({
      title: 'Move to IPD?',
      html: `Move patient <b>${row.ipd_patient_name}</b> from Emergency to IPD?<br/><small>This will create an IPD admission record.</small>`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Move to IPD',
      cancelButtonText: 'Cancel'
    });

    if (!isConfirmed) return;

    Swal.fire({
      title: 'Moving to IPD...',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading()
    });

    try {
      const fd = new FormData();
      fd.append('emergency_id', row.ipd_id);
      
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.moveEmergencyToIPDUrl,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      Swal.close();

      if (response?.data?.status) {
        toast.success('Patient moved to IPD successfully');
        initData(); // Refresh list
        
        // ✅ Navigate to ipd_pataint_list
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Patient moved to IPD',
          showCancelButton: true,
          confirmButtonText: 'Go to IPD List',
          cancelButtonText: 'Stay Here'
        }).then((result) => {
          if (result.isConfirmed) {
            navigate('/ipd_pataint_list'); // ✅ Updated path
          }
        });
      } else {
        toast.error(response?.data?.message || 'Failed to move patient to IPD');
      }
    } catch (err) {
      Swal.close();
      console.error('Move to IPD error:', err);
      toast.error('Failed to move patient to IPD');
    }
  };

  // Open details modal
  const openDetails = (row) => {
    if (!row) return;
    const uhid = row.ipd_uhid || '';

    const mainHtml = `
      <div style="text-align:left; font-size:14px;">
        <div style="margin-bottom:10px;"><b>UHID:</b> ${uhid || 'N/A'}</div>
        <div style="margin-bottom:10px;"><b>Patient Reg No:</b> ${row.ipd_id || 'N/A'}</div>
        <div style="margin-bottom:10px;"><b>Name:</b> ${row.ipd_patient_name || 'N/A'}</div>
        <div style="margin-bottom:10px;"><b>Phone:</b> ${row.ipd_patient_mobile || 'N/A'}</div>
        <div style="margin-bottom:10px;"><b>Age:</b> ${row.ipd_age_year ? `${row.ipd_age_year}Y ${row.ipd_age_month || 0}M ${row.ipd_age_day || 0}D` : 'N/A'}</div>
        <div style="margin-bottom:10px;"><b>Gender:</b> ${row.ipd_patient_gender || 'N/A'}</div>
        <div style="margin-bottom:10px;"><b>Address:</b> ${row.ipd_address || 'N/A'}</div>
        <div style="margin-bottom:10px;"><b>Speciality:</b> ${row.ipd_specality_name || findNameById(row.ipd_specality, formData.cats, 'cat_id', 'cat_name') || 'N/A'}</div>
        <div style="margin-bottom:10px;"><b>Doctor:</b> ${row.ipd_refer_doctor_name || getDoctorNameById(row.ipd_refer_doctor, row) || 'N/A'}</div>
        <div style="margin-bottom:10px;"><b>Case:</b> ${row.ipd_case_name || findNameById(row.ipd_case, formData.cases, 'cat_id', 'cat_name') || 'N/A'}</div>
        <div style="margin-bottom:10px;"><b>File Number:</b> ${row.ipd_file_number || 'N/A'}</div>
        <div style="margin-bottom:10px;"><b>Registration Date:</b> ${formatServerDateLocal(row.ipd_reg_date) || 'N/A'}</div>
      </div>
    `;

    Swal.fire({
      title: `Patient Details`,
      html: mainHtml,
      width: 600,
      showCloseButton: true,
      focusConfirm: false,
      confirmButtonText: 'Close'
    });
  };

  // Filter list
  const filteredList = useMemo(() => {
    const list = formData.l1 || [];
    const fromDate = formData.from ? new Date(formData.from + 'T00:00:00') : null;
    const toDate = formData.to ? new Date(formData.to + 'T23:59:59.999') : null;
    const rawSearch = (formData.search_key || "").toString().toLowerCase().trim();

    return list.filter(item => {
      let itemDate = null;
      if (item.ipd_reg_date) itemDate = parseServerDateToLocal(item.ipd_reg_date);
      else if (item.ipd_datetime) itemDate = parseServerDateToLocal(item.ipd_datetime);

      if (fromDate || toDate) {
        if (!itemDate) return false;
        if (fromDate && itemDate < fromDate) return false;
        if (toDate && itemDate > toDate) return false;
      }

      if (!rawSearch) return true;

      const candidates = [
        item.ipd_uhid,
        item.ipd_patient_name,
        item.ipd_patient_mobile,
        item.ipd_file_number,
        String(item.ipd_id)
      ].filter(Boolean).map(x => String(x).toLowerCase());

      return candidates.some(c => c.includes(rawSearch));
    });
  }, [formData.l1, formData.from, formData.to, formData.search_key]);

  // Recalculate totals
  useEffect(() => {
    const list = filteredList || [];
    let totalAmount = 0, paidAmount = 0, dueAmount = 0, totalRegCharges = 0;

    list.forEach(item => {
      const reg = parseFloat(item.ipd_reg_charges || 0);
      const paid = parseFloat(item.ipd_paid || 0);
      const due = parseFloat(item.ipd_due || 0);
      totalAmount += reg;
      totalRegCharges += reg;
      paidAmount += paid;
      dueAmount += due;
    });

    setTotals({
      totalAmount: Number(totalAmount.toFixed(2)),
      paidAmount: Number(paidAmount.toFixed(2)),
      dueAmount: Number(dueAmount.toFixed(2)),
      totalRegCharges: Number(totalRegCharges.toFixed(2))
    });
  }, [filteredList]);

  // Delete item
  const delItem = async (editItem) => {
    const fd = new FormData();
    fd.append('ipd_id', editItem.ipd_id + "");
    
    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.delEmergencyUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (response.data.status) {
        initData();
        toast.success("Emergency Record Deleted Successfully");
      }
    } catch (error) {
      console.error("delItem error:", error);
    }
  };

  // Custom styles
  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#f1f5fb',
        color: '#405189',
        fontSize: '15px',
        fontWeight: '700',
        paddingLeft: '14px',
        paddingRight: '14px',
      }
    },
    rows: {
      style: {
        fontSize: '16px',
        minHeight: '58px',
      },
    },
    cells: {
      style: {
        paddingLeft: '14px',
        paddingRight: '14px',
        fontSize: '15px',
        lineHeight: '20px'
      }
    },
  };

  // Columns
  const columns = [
    {
      name: 'Action',
      cell: row => {
        const regStr = row.ipd_datetime || row.ipd_reg_date || null;
        const regDate = regStr ? new Date(regStr) : null;

        let modifiedAt = null;
        if (row.modified_at) modifiedAt = new Date(row.modified_at);

        const candidates = [];
        if (regDate) candidates.push(regDate);
        if (modifiedAt) candidates.push(modifiedAt);

        const latestTs = candidates.length ? candidates.reduce((a, b) => (a.getTime() > b.getTime() ? a : b)) : null;

        const MS_24H = 24 * 60 * 60 * 1000;
        const now = Date.now();

        let storedRoleIsAdmin = false;
        try {
          const raw = sessionStorage.getItem('ldata');
          if (raw) {
            const parsed = JSON.parse(raw);
            storedRoleIsAdmin = String(parsed?.role_id) === '1' || String(parsed?.roleId) === '1';
          }
        } catch (e) {
          storedRoleIsAdmin = false;
        }

        const editableByTime = latestTs ? ((now - latestTs.getTime()) < MS_24H) : true;
        const editable = storedRoleIsAdmin ? true : editableByTime;
        const editBlocked = !editable;

        const regForDelete = regDate;
        const isOlderThan24FromReg = regForDelete ? (now - regForDelete.getTime()) > MS_24H : false;
        const deleteBlocked = !storedRoleIsAdmin && (isOlderThan24FromReg || !isAdmin);

        const btnStyle = blocked => ({ opacity: blocked ? 0.5 : 1, cursor: blocked ? 'not-allowed' : 'pointer' });

        return (
          <div className="d-flex gap-2">
            <button
              type="button"
              className="btn btn-sm btn-outline-warning"
              style={btnStyle(editBlocked)}
              onClick={() => {
                if (editBlocked) {
                  Swal.fire({
                    icon: 'info',
                    title: "Edit Locked",
                    text: 'This patient was admitted 24 Hrs before',
                    confirmButtonText: 'OK'
                  });
                  return;
                }

                Swal.fire({
                  title: 'Are you sure?',
                  text: "Do you want to edit this patient's record?",
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Yes, Edit'
                }).then((result) => {
                  if (result.isConfirmed) {
                    sessionStorage.setItem("emergency_dt", JSON.stringify(row));
                    window.location.href = "/emergency_reg";
                  }
                });
              }}
            >
              <i className="ri-pencil-fill fs-16"></i>&nbsp;&nbsp;
            </button>

            <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              style={btnStyle(deleteBlocked)}
              onClick={() => {
                if (deleteBlocked) {
                  const msg = isOlderThan24FromReg ? "Deleting disabled after 24 hours." : "Only admins can delete this record.";
                  Swal.fire({ icon: 'info', title: "Can't Delete", text: msg, confirmButtonText: 'OK' });
                  return;
                }
                Swal.fire({
                  title: 'Are you sure?',
                  text: "This will permanently delete the record.",
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Yes, delete it'
                }).then((result) => {
                  if (result.isConfirmed) {
                    delItem(row);
                  }
                });
              }}
            >
              <i className="ri-delete-bin-5-fill fs-16"></i>&nbsp;&nbsp;
            </button>
          </div>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '220px'
    },
    {
      name: '',
      cell: row => (
        <button
          className="btn btn-sm btn-primary view-btn"
          onClick={(e) => {
            e.stopPropagation();
            openDetails(row);
          }}
          title="View"
          style={{ minWidth: 64 }}
        >
          View
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '90px'
    },
    {
      name: 'SN',
      selector: (row) => {
        const idxInFiltered = filteredList.findIndex(i => i.ipd_id === row.ipd_id);
        return idxInFiltered + 1;
      },
      sortable: true,
      width: '90px'
    },
    {
      name: 'Patient Reg No',
      selector: row => row.ipd_id || '',
      sortable: true,
      width: '150px'
    },
    {
      name: 'UHID',
      selector: row => row.ipd_uhid || '',
      sortable: true,
      width: '180px'
    },
    {
      name: 'Registration Date',
      selector: row => formatServerDateLocal(row.ipd_reg_date) || '',
      sortable: true,
      width: '180px'
    },
    {
      name: 'Patient Name',
      selector: row => `${row.ipd_patient_title || ''} ${row.ipd_patient_name || ''}`,
      sortable: true,
      width: '170px'
    },
    {
      name: 'Mobile',
      selector: row => row.ipd_patient_mobile || '',
      sortable: true,
      width: '140px'
    },
    {
      name: 'File Number',
      selector: row => row.ipd_file_number || '',
      sortable: true,
      width: '140px'
    },
    {
      name: 'Doctor',
      selector: row => getDoctorNameById(row.ipd_refer_doctor, row),
      sortable: true,
      width: '180px'
    },
    {
      name: 'Case',
      selector: row => row.ipd_case_name || findNameById(row.ipd_case, formData.cases, 'cat_id', 'cat_name'),
      sortable: true,
      width: '150px'
    },
  ];

  // ✅ Expandable row actions with conditional buttons
  const ExpandedActions = ({ data: row }) => {
    const patientDataForModal = {
      ipd_bill_uhid: row.ipd_uhid || '',
      ipd_no: row.ipd_id || '',
      ipd_bill_patient_name: row.ipd_patient_name || '',
      ipd_bill_patient_age: row.ipd_age_year ? `${row.ipd_age_year}Y ${row.ipd_age_month || 0}M ${row.ipd_age_day || 0}D` : '',
      ipd_bill_patient_gender: row.ipd_patient_gender || '',
      ipd_bill_patient_phone: row.ipd_patient_mobile || '',
      ipd_bill_patient_address: row.ipd_address || '',
      procedure_bill_id: row.procedure_bill_id || ''
    };

    const movedToIPD = isMovedToIPD(row);
    const hasProcedureBill = row.procedure_bill_id && row.procedure_bill_id !== '';

    return (
      <div style={{ padding: '10px 14px', borderTop: '1px solid #eee', display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
        {/* ✅ Procedure Bill Button - Shows EDIT if bill exists, otherwise Add */}
        {hasProcedureBill ? (
          <button 
            className="btn btn-sm btn-outline-warning"
            onClick={() => {
              setSelectedPatient(patientDataForModal);
              setShowProcedureModal(true);
            }}
          >
            <i className="ri-edit-line"></i>&nbsp;EDIT Procedure Bill
          </button>
        ) : (
          <button 
            className="btn btn-sm btn-outline-success"
            onClick={() => {
              setSelectedPatient(patientDataForModal);
              setShowProcedureModal(true);
            }}
          >
            <i className="ri-money-dollar-circle-line"></i>&nbsp;Add Procedure Bill
          </button>
        )}

        {/* ✅ Move to IPD Button - Shows "Moved to IPD" if already moved */}
        {movedToIPD ? (
          <button 
            className="btn btn-sm btn-secondary"
            disabled
            style={{ cursor: 'not-allowed' }}
          >
            <i className="ri-check-line"></i>&nbsp;Moved to IPD
          </button>
        ) : (
          <button 
            className="btn btn-sm btn-outline-primary"
            onClick={() => handleMoveToIPD(row)}
          >
            <i className="ri-hospital-line"></i>&nbsp;Move to IPD
          </button>
        )}
      </div>
    );
  };

  return (
    <div className="page-content">
      <style>{hoverStyle}</style>

      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card" id="orderList">
              <div className="card-header border-0">
                <div className="row align-items-center gy-3">
                  <div className="col-sm">
                    <h2 style={{ color: "#405189" }}>Emergency / DayCare Patient List</h2>
                  </div>
                  <div className="col-sm-auto">
                    <div className="d-flex gap-1 flex-wrap">
                      <button
                        type="button"
                        className="btn btn-success add-btn"
                        onClick={() => {
                          try {
                            sessionStorage.removeItem("emergency_dt");
                          } catch (e) { }
                          navigate('/emergency_reg');
                        }}
                      >
                        <i className="ri-add-line align-bottom me-1"></i> Add Patient
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-body border border-dashed border-end-0 border-start-0">
                <form>
                  <div className="row g-3">
                    <div className="col-md-2">
                      <label className="form-label">From</label>
                      <input 
                        className="form-control" 
                        type="date" 
                        name="from" 
                        onChange={(e) => setFormData(prev => ({ ...prev, from: e.target.value }))} 
                        value={formData.from} 
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">To</label>
                      <input 
                        className="form-control" 
                        type="date" 
                        name="to" 
                        onChange={(e) => setFormData(prev => ({ ...prev, to: e.target.value }))} 
                        value={formData.to} 
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Search</label>
                      <div className="search-box" style={{ display: "flex" }}>
                        &nbsp;&nbsp;&nbsp;
                        <button 
                          type="button" 
                          onClick={() => {
                            const todayStr = getLocalYYYYMMDD();
                            setFormData(prev => ({ ...prev, search_key: "", from: todayStr, to: todayStr, page_no: 0 }));
                            initData({ from: todayStr, to: todayStr, search_key: "" });
                          }} 
                          className="btn btn-info"
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                    <div className="col-md-3"></div>
                    <div className="col-md-3" style={{ textAlign: "right" }}>
                      <label className="form-label"></label>
                      <div className="search-box">
                        <input 
                          className="form-control search" 
                          placeholder="Search..." 
                          type="text"
                          name="search_key" 
                          onChange={(e) => setFormData(prev => ({ ...prev, search_key: e.target.value }))} 
                          value={formData.search_key} 
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <br />

              <div className="card-body pt-0">
                <div>
                  <div className="table-responsive table-card mb-1">
                    <DataTable
                      columns={columns}
                      data={filteredList}
                      pagination
                      highlightOnHover
                      responsive
                      persistTableHead
                      customStyles={customStyles}
                      noHeader
                      expandableRows
                      expandableRowsComponent={ExpandedActions}
                      expandableRowExpanded={row => true}
                      expandOnRowClicked={false}
                    />
                  </div>

                  <div className="d-flex justify-content-between align-items-center">
                    <div className="pagination-wrap hstack gap-2">
                      <div className="text-muted">
                        <strong>Total Amount:</strong> {totals.totalAmount} &nbsp;|&nbsp;
                        <strong>Paid Amount:</strong> {totals.paidAmount} &nbsp;|&nbsp;
                        <strong>Due Amount:</strong> {totals.dueAmount} &nbsp;|&nbsp;
                        <strong>Total Registration Charges:</strong> {totals.totalRegCharges}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Procedure Bill Modal */}
      {showProcedureModal && selectedPatient && (
        <ProcedureBillModal
          patientData={selectedPatient}
          onClose={() => {
            setShowProcedureModal(false);
            setSelectedPatient(null);
            initData(); // Refresh list after closing modal
          }}
          image={headerLogo}
        />
      )}
    </div>
  );
};

export default EmergencyPatientList;